// Defined routes for all pages
export const CONTACT = "/contact";
export const ABOUT_US = "/about-us";
export const REGISTER = "/register";
export const LOGIN = "/login";
export const HOME = "/";
export const NOT_FOUND = "/404";
export const PLANJOURNEY = "/planjourney";
export const ITINERARY = "/itinerary";

export const ALNWICKCASTLESEARCH = "/alnwickcastlesearch";
export const ALNWICKCASTLESEARCHRETURN = "/alnwickcastlesearchreturn";

export const AUCKLANDCASTLESEARCH = "/aucklandcastlesearch";
export const AUCKLANDCASTLESEARCHRETURN = "/aucklandcastlesearchreturn";

export const BAMBURGHCASTLESEARCH = "/bamburghcastlesearch";
export const BAMBURGHCASTLESEARCHRETURN = "/bamburghcastlesearchreturn";

export const BARNARDCASTLESEARCH = "/barnardcastlesearch";
export const BARNARDCASTLESEARCHRETURN = "/barnardcastlesearchreturn";

